import "whatwg-fetch";

import Action from "../action/Action.ts";

const PaymentAction = {
    updateRefund(token: string, book_id: string, amount: number, callback: (data: unknown) => void, errorHandler: (error: unknown) => void) {
        const path = "/admin/payments/refund";
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        const body = JSON.stringify({
            refund_amount: amount,
            book_id: book_id,
        });
        Action.fetchAuthorizedJson(path, token, "PATCH", headers, body, callback, errorHandler);
    },
};

export default PaymentAction;
